<template lang="pug">
div
    button.button.is-large.is-fullwidth.is-dark(@click="select_company") {{button_label}}
    #cmp_select.modal
      .modal-background
      .modal-card
        .modal-card-head
          .title(style="color:black") {{select_company_heading}}
        .modal-card-body
          button.button.is-large.is-fullwidth.is-dark(v-for="cmp in companies", @click="select(cmp)") {{cmp.name}}
          button(style="margin:1rem").button.is-large.is-light(@click="cancel") {{cancel_message}}
    #cmp_timer_prompt.modal
      .modal-background
      StopTimers(@prompt-closed="close_prompt")
</template>

<script>
import { mapState } from "vuex";
import StopTimers from "@/components/StopTimers";
export default {
  name: "CompanySwitcher",
  components: {
    StopTimers
  },
  computed: {
    ...mapState(["language", "companies"]),
    button_label() {
      if (this.language == "en") {
        return "Select Company";
      } else {
        return "Seleccione empresa";
      }
    },
    cancel_message() {
      if (this.language == "en") {
        return "Cancel";
      } else {
        return "Cancelar";
      }
    },
    select_company_heading() {
      if (this.language == "en") {
        return "Select Company";
      } else {
        return "Seleccione empresa";
      }
    }
  },
  props: {},
  date: function() {
    return {};
  },

  methods: {
    select_company() {
      if (this.$store.getters.active_timers) {
        document.getElementById("cmp_timer_prompt").classList.add("is-active");
      } else {
        document.getElementById("cmp_select").classList.add("is-active");
      }
    },
    select(cmp) {
      this.$store.commit("company", cmp);
      document.getElementById("cmp_select").classList.remove("is-active");
    },
    cancel() {
      document.getElementById("cmp_select").classList.remove("is-active");
    },
    close_prompt() {
      document.getElementById("cmp_timer_prompt").classList.remove("is-active");
    }
  }
};
</script>

<style scoped lang="less">
.modal-card {
  max-width: 500px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
</style>
